import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, SubMenu, MenuItem } from 'react-pro-sidebar';
import {
  AppWindow,
  Megaphone,
  ChartArea,
  ChevronLeft,
  CloudUpload,
  Columns4,
  Settings,
  Database,
  FileBraces,
  Fingerprint,
  FlaskConical,
  Home,
  ExternalLink,
  Languages,
  Gauge,
  ShieldHalf,
  ShieldCheck,
  BarChart3,
  TabletSmartphone,
  Boxes,
  ClipboardList,
  Copy,
  LayoutDashboard,
  MessageSquare
} from 'lucide-react';
import WipPill from '../common/WipPill';
import './LeftNavMenu.css';

function LeftNavMenu({ showDemoEnvMgmt }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="navbar-container" >
      <div className={`navbar-wrapper ${collapsed ? 'collapsed' : ''}`}>
        <button
          className={`navbar-toggle-button ${collapsed ? 'collapsed' : ''}`}
          onClick={() => setCollapsed(!collapsed)}
          aria-label="Toggle sidebar"
        >
          <ChevronLeft size={20} />
        </button>
        <Menu className="navbar-main-menu">
          <MenuItem icon={<Home size={20} />} component={<Link to="/home" />}>Home</MenuItem>
          <SubMenu icon={<AppWindow size={20} />} label="Application">
            <MenuItem icon={<ChartArea size={20} />} component={<Link to="/application/tests-monitoring" />}>Test monitoring</MenuItem>
          </SubMenu>
          <SubMenu icon={<Database size={20} />} label="Data processing">
            <MenuItem icon={<Fingerprint size={20} />} component={<Link to="/data/user-id-hasher" />}>User ID hasher</MenuItem>
          </SubMenu>
          <SubMenu icon={<CloudUpload size={20} />} label="Data collection">
            <SubMenu icon={<TabletSmartphone size={20} />} label="Mobile">
              <MenuItem icon={<ChartArea size={20} />} component={<Link to="/mobile/tests-monitoring" />}>Test monitoring</MenuItem>
              <MenuItem icon={<Columns4 size={20} />} component={<Link to="/mobile/tests-quarantine" />}>Test quarantine</MenuItem>
              <MenuItem icon={<Gauge size={20} />} suffix={<WipPill />} component={<Link to="/mobile/sdk-performance" />}>SDK Performance</MenuItem>
            </SubMenu>
            <SubMenu icon={<FileBraces size={20} />} label="Tag">
              <MenuItem icon={<ChartArea size={20} />} component={<Link to="/tag/tests-monitoring" />}>Test monitoring</MenuItem>
            </SubMenu>
          </SubMenu>
          <SubMenu icon={<ShieldHalf size={20} />} label="Quality">
            <MenuItem icon={<Megaphone size={20} />} component={<Link to="/quality/campaigns" />}>Test campaigns</MenuItem>
            <MenuItem icon={<BarChart3 size={20} />} component={<Link to="/quality/kpi-dashboard" />}>Quality KPI</MenuItem>
            <MenuItem icon={<FlaskConical size={20} />} component={<Link to="/quality/tests-management" />}>Tests management</MenuItem>
            <MenuItem icon={<Gauge size={20} />} component={<Link to="/quality/software-test-report" />}>Software Test Report</MenuItem>
            <SubMenu icon={<ShieldCheck size={20} />} label="Sense Shield">
              <MenuItem icon={<LayoutDashboard size={20} />} component={<Link to="/sense-shield/summary" />}>Summary</MenuItem>
              <MenuItem icon={<ChartArea size={20} />} component={<Link to="/sense-shield/evaluation-runs" />}>Evaluation Runs</MenuItem>
              <MenuItem icon={<MessageSquare size={20} />} component={<Link to="/sense-shield/feedback-loop" />}>Feedback Loop</MenuItem>
            </SubMenu>
          </SubMenu>
          <SubMenu icon={<ClipboardList size={20} />} label="Bug Management">
            <MenuItem icon={<Copy size={20} />} component={<Link to="/bug-management/duplicate-tickets" />}>Duplicate Tickets</MenuItem>
          </SubMenu>
          <MenuItem icon={<Settings size={20} />} component={<Link to="/system-e2e" />}>System E2E</MenuItem>
          <MenuItem icon={<Languages size={20} />} component={<Link to="/translation-anomaly" />}>Translation Anomaly</MenuItem>
          {showDemoEnvMgmt && (
            <MenuItem icon={<Boxes size={20} />} component={<Link to="/demo-env-mgmt" />}>Sales demo mgmt</MenuItem>
          )}
        </Menu>

        <Menu className="navbar-bottom-menu">
          <MenuItem
            icon={<ExternalLink size={20} />}
            onClick={() => window.open('https://app.contentsquare.com/#/site-overview?project=135004', '_blank', 'noopener,noreferrer')}
          >
            Open in CSQ
          </MenuItem>
        </Menu>
      </div>

    </div>
  );
}

export default LeftNavMenu;
